import { useEffect } from "react";
import { socket } from "./soket";
import useStore from "../store";

function NextLevel() {
  const launch_nextlevel = useStore((state) => state.launch_nextlevel);
  const modalError = useStore((state) => state.modalError);
  const modalEndGame = useStore((state) => state.modalEndGame);

  useEffect(() => {
    socket.on("step", (data) => {
      if (data.error) {
        modalError(data.error);
      } else if (data.endgame === true) {
        modalEndGame(data);
      } else {
        launch_nextlevel(data);
      }
    });
  }, []);
  return null;
}

export default NextLevel;
